import { DataTypeStore } from '../types';
import { IUserListType, UserListState } from '../types/userlist.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: UserListState = {
  userData: [],
  totalPages: 0,
  userCompleteData: [],
  selected: null,
};

const userListSlice = createSlice({
  name: 'userlist',
  initialState: initialState,
  reducers: {
    updateUserListByPage: (
      state: UserListState,
      action: PayloadAction<{
        data: { content: DataTypeStore[]; totalPages: number };
      }>
    ) => {
      if (action.payload.data) {
        state.userData = action.payload.data.content;
        state.totalPages = action.payload.data.totalPages;
      }
    },
    updateUserAssignedRoleList: (
      state: UserListState,
      action: PayloadAction<{ data: IUserListType[] }>
    ) => {
      state.userCompleteData = action.payload.data;
    },
    updateUserList: (
      state: UserListState,
      action: PayloadAction<{ data: { content: IUserListType[] } }>
    ) => {
      state.userCompleteData = action.payload.data.content;
    },
    updateSelectedUser: (
      state: UserListState,
      action: PayloadAction<IUserListType | null>
    ) => {
      state.selected = action.payload;
    },
    getAllUsersByPageAction: () => {
      return;
    },
    getAllUsersAction: () => {
      return;
    },
    getAllUsersAssignRolesAction: () => {
      return;
    },
    getSingleUserAction: () => {
      return;
    },
    patchToggleUpdateDisableAction: () => {
      return;
    },
    patchToggleUpdateDisableBulkAction: () => {
      return;
    },
    patchToggleUpdateEnableAction: () => {
      return;
    },
    patchToggleUpdateEnableBulkAction: () => {
      return;
    },
    getUserDataBySortAction: () => {
      return;
    },
    getUserDataBySearchAction: () => {
      return;
    },
    deleteUserAction: () => {
      return;
    },
  },
});

export const {
  updateUserListByPage,
  updateSelectedUser,
  getAllUsersByPageAction,
  updateUserList,
  getAllUsersAction,
  getAllUsersAssignRolesAction,
  getSingleUserAction,
  patchToggleUpdateEnableAction,
  patchToggleUpdateEnableBulkAction,
  patchToggleUpdateDisableAction,
  patchToggleUpdateDisableBulkAction,
  getUserDataBySortAction,
  getUserDataBySearchAction,
  updateUserAssignedRoleList,
  deleteUserAction
} = userListSlice.actions;
export default userListSlice.reducer;
